import BaseMetricCard, {
  MetricCardConfig,
} from "../../../Common/BaseMetricCard";
import { WellnessScoreStatus } from "../../../Common/types";

export interface HeartRateCardProps {
  metricValue: string;
  status: WellnessScoreStatus;
  lastUpdated?: string;
  onManualEntryClick?: () => void;
}

const config: MetricCardConfig = {
  translationPrefix: "HeartRate",
  analyticsSource: "Health Score - heart rate",
  manualEntryRoute: "/home/health-score/heart-rate-manual-entry",
};

export default function HeartRateCard(props: HeartRateCardProps) {
  return <BaseMetricCard {...props} config={config} />;
}
